import { render, staticRenderFns } from "./TablePlus.vue?vue&type=template&id=17782496&scoped=true&"
import script from "./TablePlus.vue?vue&type=script&lang=js&"
export * from "./TablePlus.vue?vue&type=script&lang=js&"
import style0 from "./TablePlus.vue?vue&type=style&index=0&id=17782496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17782496",
  null
  
)

export default component.exports